<template>
    <div class="main_wrap">
        <div class="media_sign">
    <div class="btn_group">
        <div @click="toapply">
            <span>媒体证申请</span>
            <span>APPLY</span>
        </div>
        <div @click="toFind">
            <span>我的媒体证</span>
            <span>CERTIFICATE</span>
        </div>
    </div>
  </div>
    </div>

</template>

<script>
export default {
    methods:{
        toapply(){
            this.$router.push({path:'/foreignMedia'})
        },
        toFind(){
            this.$router.push({path:'/findTicket'})
        }
    }
}
</script>

<style lang="scss" scoped>
.media_sign {
//   width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-image: url("https://faststatic.ccnfgame.com/cos/vrshow/exhibiton/gzcz/img_background_1.png");
  display: flex;
  justify-content: center;
  margin: 0 auto;
  flex-direction: column;
  .btn_group {
    width: 100%;
    display: flex;
    // justify-content: space-around;
    align-items: center;
    font-size: 50px;
    color: #fff;
    flex-direction: column;
    > div {
        width: 600px;
      height: 300px;
      line-height:110px;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 20px;
      cursor: pointer;
      margin:20px 0px;
      font-size: 80px;
      font-weight: bold;
      padding: 0px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

}

@media screen and (min-width: 100px) and (max-width: 1000px) {
  .media_sign{
    width: 100vw;
  }

}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
    .media_sign {
        width: 852px;
        .btn_group {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 50px;
    color: #fff;
    flex-direction: column;
    > div {
        width: 300px;
      height: 200px;
      line-height:60px;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 20px;
      cursor: pointer;
      margin:10px 0px;
      font-size: 40px;
      font-weight: bold;
      padding: 0px 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
        
    }

    

}

</style>


// WEBPACK FOOTER //
// foreignMediaMain.vue?066a97a8